<div class="kt-portlet lum-page lum-page__card lum-c-stocks">
  <div class="kt-portlet__head">
    <div class="kt-portlet__head-label">
      <span class="kt-portlet__head-icon">
        <i class="fas fa-chart-line"></i>
      </span>
      <h3 class="kt-portlet__head-title">Inventory Stocks</h3>
    </div>
    <div class="kt-portlet__head-toolbar">
      <button
        class="btn btn-secondary"
        type="button"
        [routerLink]="['/inventory/adjustment-entries/create']"
      >
        <i class="fas fa-industry"></i> New Inventory Adjustment Entry
      </button>
    </div>
  </div>

  <kt-portlet-body>
    <div class="toolbar">
      <div class="kt-widget filter">
        <div class="form-group">
          <label>SKU</label>
          <input
            type="text"
            class="form-control w300"
            placeholder="Enter SKU"
            [(ngModel)]="filter.sku"
            (keyup.enter)="getRecords(false, 1)"
          />
        </div>
        <div class="form-group">
          <label>Product Name</label>
          <input
            type="text"
            class="form-control w300"
            placeholder="Enter Product Name"
            [(ngModel)]="filter.productName"
            (keyup.enter)="getRecords(false, 1)"
          />
        </div>
        <div class="form-group">
          <label>Product Type</label>
          <select
            class="form-control"
            [(ngModel)]="filter.product_type"
            (change)="getRecords(false, 1)"
          >
            <option value="">All</option>
            <option value="PRODUCT">PRODUCT</option>
            <option value="KIT">KIT</option>
          </select>
        </div>

        <div class="form-group">
          <label>Category</label>
          <ng-select
            [items]="categorySvc._productCategories | async"
            bindValue="id"
            bindLabel="product_category"
            [(ngModel)]="filter.categoryId"
            (change)="getRecords(false, 1)"
            multiple="true"
            [loading]="categorySvc.gettingRecords"
          >
          </ng-select>
        </div>

        <div class="form-group">
          <label>Sub Category</label>
          <ng-select
            [items]="subcategorySvc._subCategories | async"
            bindValue="id"
            bindLabel="sub_category"
            [(ngModel)]="filter.subcategoryIds"
            (change)="getRecords(false, 1)"
            multiple="true"
            [loading]="subcategorySvc.gettingRecords"
          >
          </ng-select>
        </div>

        <div class="form-group">
          <label>Status</label>
          <select
            class="form-control"
            [(ngModel)]="filter.discontinued"
            (change)="getRecords(false, 1)"
          >
            <option value="2">All</option>
            <option value="0">Active</option>
            <option value="1">Discontinued</option>
          </select>
        </div>

        <div class="form-group mw-200">
          <label>Warehouse Group</label>
          <ng-select
            [items]="warehouseGroups$ | async"
            bindValue="id"
            bindLabel="label"
            multiple="true"
            [trackByFn]="trackWarehouseGroupByFn"
            [loading]="(warehouseGroupLoading$ | async) || false"
            [(ngModel)]="filter.warehouseGroupIds"
            (change)="onSelectWarehouseGroup($event)"
            (clear)="onResetWarehouseGroupFilter()"
          >
          </ng-select>
        </div>

        <div class="form-group mw-200">
          <label>Warehouse</label>
          <ng-select
            [items]="warehouses"
            bindValue="id"
            bindLabel="locationName"
            multiple="true"
            [(ngModel)]="filter.warehouseIds"
            (change)="getRecords(false, 1)"
          >
          </ng-select>
        </div>

        <div class="form-group">
          <label>Costs</label>
          <input
            class="form-control"
            type="number"
            [(ngModel)]="filter.costs"
            (change)="getRecords(false, 1)"
          />
        </div>

        <div class="form-group">
          <label>Last updated at</label>
          <input
            type="date"
            class="form-control"
            [(ngModel)]="filter.last_updated"
            (keyup.enter)="getRecords(false, 1)"
            (change)="getRecords(false, 1)"
          />
        </div>

        <mat-checkbox
          class="px-2"
          color="primary"
          [(ngModel)]="filter.no_stock_skus"
          (change)="getRecords(false, 1)"
        >
          No stock SKUs
        </mat-checkbox>

        <div class="d-flex justify-content-end">
          <div class="form-group">
            <button class="btn btn-outline-info btn-sm" (click)="resetFilters()">
              <i class="fas fa-eraser"></i> Reset Filters
            </button>
          </div>

          <div class="form-group">
            <div ngbDropdown class="d-inline-block">
              <button
                class="btn btn-outline-primary btn-sm"
                id="action-button"
                ngbDropdownToggle
              >
                <i class="icon fas fa-file-export"></i>
                <span class="text"
                  >Export SKUs <i class="fas fa-caret-down"></i
                ></span>
              </button>
              <div ngbDropdownMenu aria-labelledby="action-button">
                <button ngbDropdownItem (click)="exportRfqNumber()">
                  <i class="fas fa-file-csv"></i> Export Inventory Numbers to CSV
                </button>
                <button ngbDropdownItem (click)="exportKitNumber()">
                  <i class="fas fa-file-csv"></i> Export Inventory Kit Numbers to
                  CSV
                </button>
              </div>
            </div>
          </div>

          <div class="form-group">
            <div ngbDropdown class="d-inline-block">
              <button
                ngbDropdownToggle
                type="button"
                class="btn btn-outline-info btn-sm"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <span class="text">Reset Baseline to Zero</span>
              </button>

              <label class="toggle-locations" *ngIf="ftLocationBins">
                <input type="checkbox" [(ngModel)]="showLocations" />
                Toggle locations
              </label>

              <div ngbDropdownMenu aria-labelledby="action-button">
                <div class="col" *ngIf="loadingWh; else loadWarehouse">
                  <i class="fas fa-spinner fa-spin"></i>
                  <span>Getting records..</span>
                </div>
                <ng-template #loadWarehouse>
                  <div class="col" *ngFor="let wh of warehouses; let i = index">
                    <input
                      type="checkbox"
                      name="{{ wh.id }}"
                      [value]="wh.id"
                      (change)="getSelectedWarehouseId($event, wh.id)"
                      class="px-2"
                    />
                    <span class="mr-2">
                      {{ wh.locationName }}
                    </span>
                  </div>
                </ng-template>
                <div class="col">
                  <button
                    class="btn btn-outline-success btn-sm"
                    (click)="resetSelectedWarehouse()"
                  >
                    Reset Selected
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <button
              class="btn btn-outline-success btn-sm"
              (click)="recountPending()"
            >
              Resync Pending
            </button>
          </div>

          <div class="form-group">
            <button
              class="btn btn-outline-success btn-sm"
              (click)="pullExternalWarehouseStocks()"
            >
              Pull External Warehouse Stocks
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="overflow-auto result">
      <table class="table table-striped table-hover lum-table lum-table--classic">
        <thead>
          <tr>
            <th class="sku">SKU</th>
            <th>Product Name</th>
            <th class="lum-c-stocks__table-multicell-headers">
              <div class="lum-c-stocks__table-multicell-headers__header">
                <div class="col-h">Warehouse</div>
                <div class="col-h" *ngIf="showLocations">Location</div>
                <div class="col-h" *ngIf="showLocations && ftLotTracking">
                  Lot Number
                </div>
                <div class="col-h text-right">Incoming</div>
                <div class="col-h text-right">Onhand</div>
                <div class="col-h text-right">Pending</div>
                <div class="col-h text-right">Available</div>
              </div>
            </th>

            <th class="text-right" *ngIf="UserPermission.can('viewUnitCost')">
              FIFO Cost
            </th>

            <th>&nbsp;</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngIf="loading">
            <td colspan="10" class="text-center">
              <br />
              <h6 [translate]="'GENERAL.GETTING_RECORDS'">
                <i class="fas fa-spinner fa-spin"></i> Getting records...
              </h6>
              <br />
            </td>
          </tr>

          <tr *ngFor="let r of records.data; let i = index">
            <td>
              <a
                href="javascript:;"
                target="_blank"
                [routerLink]="['/inventory/' + r.id + '/view']"
                routerLinkActive="router-link-active"
                title="View SKU purchase orders"
              >
                {{ r.internal_sku }}
              </a>
            </td>
            <td>
              <div class="product-name">
                {{ r.product_name }}
              </div>
            </td>
            <td>
              <div
                *ngFor="let stock of filterLocations(r.location_stocks)"
                class="master-entry"
              >
                <div class="entries">
                  <div class="col-h">
                    {{
                      stock.warehouse
                        ? stock.warehouse.location_name
                        : stock.warehouse_id > 0
                          ? 'DELETED WAREHOUSE'
                          : 'GENERAL'
                    }}
                  </div>
                  <div class="col-h" *ngIf="showLocations"></div>
                  <div class="col-h" *ngIf="showLocations && ftLotTracking"></div>
                  <div class="col-h text-right">
                    <ng-container
                      *ngIf="r.type === 'KIT' || stock.qty_incoming <= 0"
                    >
                      <span>
                        {{ stock.qty_incoming | decimalPlaces }}
                        <ng-container *ngIf="!hideUom">
                          {{ r?.base_unit_of_measure?.name }}
                        </ng-container>
                        <ng-container
                          *ngIf="
                            !hideUom &&
                            r.conversion_factor &&
                            (r?.default_selling_unit?.name !==
                              r?.base_unit_of_measure?.name ||
                              (stock.qty_incoming | decimalPlaces) !==
                                (stock.qty_incoming / r.conversion_factor
                                  | decimalPlaces))
                          "
                        >
                          /
                          {{
                            stock.qty_incoming / r.conversion_factor | decimalPlaces
                          }}
                          {{ r?.default_selling_unit?.name }}
                        </ng-container>
                      </span>
                    </ng-container>
                    <ng-container
                      *ngIf="
                        !(r.type === productTypes.KIT || stock.qty_incoming === 0)
                      "
                    >
                      <button
                        type="button"
                        [class]="'linkish'"
                        title="View SKU purchase orders"
                        (click)="
                          onViewIncomingRfqStockDetails(stock.warehouse_id, r)
                        "
                      >
                        {{ stock.qty_incoming | decimalPlaces }}
                        <ng-container *ngIf="!hideUom">
                          {{ r?.base_unit_of_measure?.name }}
                        </ng-container>
                        <ng-container
                          *ngIf="
                            !hideUom &&
                            r.conversion_factor &&
                            (r?.default_selling_unit?.name !==
                              r?.base_unit_of_measure?.name ||
                              (stock.qty_incoming | decimalPlaces) !==
                                (stock.qty_incoming / r.conversion_factor
                                  | decimalPlaces))
                          "
                        >
                          /
                          {{
                            stock.qty_incoming / r.conversion_factor | decimalPlaces
                          }}
                          {{ r?.default_selling_unit?.name }}
                        </ng-container>
                      </button>
                    </ng-container>
                  </div>
                  <div class="col-h text-right">
                    {{ stock.qty_onhand | decimalPlaces }}
                    <ng-container *ngIf="!hideUom">
                      {{ r?.base_unit_of_measure?.name }}
                    </ng-container>
                    <ng-container
                      *ngIf="
                        !hideUom &&
                        r.conversion_factor &&
                        (r?.default_selling_unit?.name !==
                          r?.base_unit_of_measure?.name ||
                          (stock.qty_onhand | decimalPlaces) !==
                            (stock.qty_onhand / r.conversion_factor
                              | decimalPlaces))
                      "
                    >
                      /
                      {{ stock.qty_onhand / r.conversion_factor | decimalPlaces }}
                      {{ r?.default_selling_unit?.name }}
                    </ng-container>
                  </div>
                  <div class="col-h text-right">
                    {{ stock.qty_pending | decimalPlaces }}
                    <ng-container *ngIf="!hideUom">
                      {{ r?.base_unit_of_measure?.name }}
                    </ng-container>
                    <ng-container
                      *ngIf="
                        !hideUom &&
                        r.conversion_factor &&
                        (r?.default_selling_unit?.name !==
                          r?.base_unit_of_measure?.name ||
                          (stock.qty_pending | decimalPlaces) !==
                            (stock.qty_pending / r.conversion_factor
                              | decimalPlaces))
                      "
                    >
                      /
                      {{ stock.qty_pending / r.conversion_factor | decimalPlaces }}
                      {{ r?.default_selling_unit?.name }}
                    </ng-container>
                  </div>
                  <div class="col-h text-right">
                    <span
                      [ngClass]="{
                        'text-danger font-500':
                          r.qty_limit_notify > 0 &&
                          stock.qty_available <= r.qty_limit_notify,
                      }"
                    >
                      {{ stock.qty_available | decimalPlaces }}
                      <ng-container *ngIf="!hideUom">
                        {{ r?.base_unit_of_measure?.name }}
                      </ng-container>
                      <ng-container
                        *ngIf="
                          !hideUom &&
                          r.conversion_factor &&
                          (r?.default_selling_unit?.name !==
                            r?.base_unit_of_measure?.name ||
                            (stock.qty_available | decimalPlaces) !==
                              (stock.qty_available / r.conversion_factor
                                | decimalPlaces))
                        "
                      >
                        /
                        {{
                          stock.qty_available / r.conversion_factor | decimalPlaces
                        }}
                        {{ r?.default_selling_unit?.name }}
                      </ng-container>
                    </span>
                  </div>
                </div>
                <ng-container>
                  <div class="entries" *ngFor="let l of stock.stock_locations">
                    <div class="col-h"></div>
                    <div class="col-h" *ngIf="showLocations">
                      <cnc-picklist-location
                        [pickingLocation]="l.is_pick_location"
                      ></cnc-picklist-location>
                      {{ l.location_name }}
                    </div>
                    <div class="col-h" *ngIf="showLocations && ftLotTracking">
                      <span *ngIf="ftLotTracking && r.lot_tracking">
                        {{ l.pivot?.lot?.lot_number }}
                      </span>
                    </div>
                    <div class="col-h"></div>
                    <div class="col-h text-right">
                      {{ l.pivot?.onhand_quantity | decimalPlaces }}
                      <ng-container *ngIf="!hideUom">
                        {{ r?.base_unit_of_measure?.name }}
                      </ng-container>
                      <ng-container
                        *ngIf="
                          !hideUom &&
                          r.conversion_factor &&
                          (r?.default_selling_unit?.name !==
                            r?.base_unit_of_measure?.name ||
                            (l.pivot?.onhand_quantity | decimalPlaces) !==
                              (l.pivot?.onhand_quantity / r.conversion_factor
                                | decimalPlaces))
                        "
                      >
                        /
                        {{
                          l.pivot?.onhand_quantity / r.conversion_factor
                            | decimalPlaces
                        }}
                        {{ r?.default_selling_unit?.name }}
                      </ng-container>
                    </div>
                  </div>
                </ng-container>
              </div>
              <div
                class="total-entries"
                *ngIf="filterLocations(r.location_stocks).length > 1"
              >
                <div class="col-h">
                  <b>TOTAL</b>
                </div>
                <div class="col-h" *ngIf="showLocations">&nbsp;</div>
                <div class="col-h" *ngIf="showLocations && ftLotTracking">
                  &nbsp;
                </div>
                <div class="col-h text-right">
                  {{
                    (r.stock.qty_incoming > 0 ? r.stock.qty_incoming : 0)
                      | decimalPlaces
                  }}
                  <ng-container *ngIf="!hideUom">
                    {{ r?.base_unit_of_measure?.name }}
                  </ng-container>
                  <ng-container
                    *ngIf="
                      !hideUom &&
                      r.conversion_factor &&
                      (r?.default_selling_unit?.name !==
                        r?.base_unit_of_measure?.name ||
                        (r.stock.qty_incoming | decimalPlaces) !==
                          (r.stock.qty_incoming / r.conversion_factor
                            | decimalPlaces))
                    "
                  >
                    /
                    {{
                      (r.stock.qty_incoming / r.conversion_factor > 0
                        ? r.stock.qty_incoming / r.conversion_factor
                        : 0
                      ) | decimalPlaces
                    }}
                    {{ r?.default_selling_unit?.name }}
                  </ng-container>
                </div>
                <div class="col-h text-right">
                  {{
                    (r.stock.qty_onhand > 0 ? r.stock.qty_onhand : 0)
                      | decimalPlaces
                  }}
                  <ng-container *ngIf="!hideUom">
                    {{ r?.base_unit_of_measure?.name }}
                  </ng-container>
                  <ng-container
                    *ngIf="
                      !hideUom &&
                      r.conversion_factor &&
                      (r?.default_selling_unit?.name !==
                        r?.base_unit_of_measure?.name ||
                        (r.stock.qty_onhand | decimalPlaces) !==
                          (r.stock.qty_onhand / r.conversion_factor
                            | decimalPlaces))
                    "
                  >
                    /
                    {{
                      (r.stock.qty_onhand / r.conversion_factor > 0
                        ? r.stock.qty_onhand / r.conversion_factor
                        : 0
                      ) | decimalPlaces
                    }}
                    {{ r?.default_selling_unit?.name }}
                  </ng-container>
                </div>
                <div class="col-h text-right">
                  {{
                    (r.stock.qty_pending > 0 ? r.stock.qty_pending : 0)
                      | decimalPlaces
                  }}
                  <ng-container *ngIf="!hideUom">
                    {{ r?.base_unit_of_measure?.name }}
                  </ng-container>
                  <ng-container
                    *ngIf="
                      !hideUom &&
                      r.conversion_factor &&
                      (r?.default_selling_unit?.name !==
                        r?.base_unit_of_measure?.name ||
                        (r.stock.qty_pending | decimalPlaces) !==
                          (r.stock.qty_pending / r.conversion_factor
                            | decimalPlaces))
                    "
                  >
                    /
                    {{
                      (r.stock.qty_pending / r.conversion_factor > 0
                        ? r.stock.qty_pending / r.conversion_factor
                        : 0
                      ) | decimalPlaces
                    }}
                    {{ r?.default_selling_unit?.name }}
                  </ng-container>
                </div>
                <div class="col-h text-right">
                  <span
                    [ngClass]="{
                      'text-danger font-500':
                        r.qty_limit_notify > 0 &&
                        r.stock.qty_onhand - r.stock.qty_pending <=
                          r.qty_limit_notify,
                    }"
                  >
                    {{ r.stock.qty_onhand - r.stock.qty_pending | decimalPlaces }}
                    <ng-container *ngIf="!hideUom">
                      {{ r?.base_unit_of_measure?.name }}
                    </ng-container>
                    <ng-container
                      *ngIf="
                        !hideUom &&
                        r.conversion_factor &&
                        (r?.default_selling_unit?.name !==
                          r?.base_unit_of_measure?.name ||
                          (r.stock.qty_onhand - r.stock.qty_pending
                            | decimalPlaces) !==
                            ((r.stock.qty_onhand - r.stock.qty_pending) /
                              r.conversion_factor | decimalPlaces))
                      "
                    >
                      /
                      {{
                        (r.stock.qty_onhand - r.stock.qty_pending) /
                          r.conversion_factor | decimalPlaces
                      }}
                      {{ r?.default_selling_unit?.name }}
                    </ng-container>
                  </span>
                </div>
              </div>
            </td>

            <td class="text-right" *ngIf="UserPermission.can('viewUnitCost')">
              {{ r.unit_costs.weighted | decimalPlaces | currency: '' }}
            </td>

            <td>&nbsp;</td>
          </tr>
        </tbody>
      </table>
    </div>

    <mat-paginator
      [length]="records.total"
      [pageSize]="records.per_page"
      [pageIndex]="params.page - 1"
      s
      [pageSizeOptions]="pageSizeOptions"
      (page)="getRecords($event)"
      class="lum-paging lum-paging--dodge-back-to-top lum-paging--sticky"
    ></mat-paginator>
  </kt-portlet-body>
</div>
